module.exports = __webpack_public_path__ + "static/squareLogo-00d15a83d026c2e522bcc0b27f1897a8.png";